import initReactApp from 'dpl/util/initReactApp';
import Explore from 'dpl/breed_explorer/components/Routes';

initReactApp({ Explore });
